
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import toast, { Toaster } from 'react-hot-toast';

function Register() {
  const navigate = useNavigate();
  const [value, setValue] = useState({
    name: "",
    email: "",
    password: "",
  });
  const [error, setError] = useState(""); // For error handling

  const handleChange = (e) => {
    const { name, value } = e.target;
    setValue((prevState) => ({ ...prevState, [name]: value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const { name, email, password } = value;

    // Client-side validation
    if (!name || !email || !password) {
      setError("All fields are required.");
      return;
    }

    try {
        const response = await axios.post("https://generativebackend.onrender.com/api/register", {
        name,
        email,
        password,
      });

      // Check if registration was successful
      if (response.status === 200) {
        setValue({
          name: "",
          email: "",
          password: "",
        });
        toast.success('Registration Sucessfully',{
          duration:'3000'
        })
        navigate("/login");
      } else {
        toast.error('Check the detail',{
          duration:'5000'
        })
        setError(response.data.msg || "Registration failed. Please try again.");
      }
    } catch (error) {
      // Handle errors from the server or network issues
      
      console.error("Error:", error);
      setError(error.response?.data?.msg || "An unexpected error occurred. Please try again.");
    }
  };

  return (
    <>
      <h1 style={{textAlign:'center'}}>Registration </h1>
      <div class="container">
      <div className="card" style={{textAlign:'center'}}>
          <form onSubmit={handleSubmit}>
            <input
              type="text"
              name="name"
              id="name"
              placeholder="Name"
              value={value.name}
              onChange={handleChange}
            />
            <br />
            <input
              type="email"
              name="email"
              id="email"
              placeholder="Email"
              value={value.email}
              onChange={handleChange}
            />
            <br />
            <input
              type="password"
              name="password"
              id="password"
              placeholder="Password"
              value={value.password}
              onChange={handleChange}
            />
            <br />
            <input type="submit" value="Register" />
          </form>
          {error && <p className="error">{error}</p>} {/* Display error messages */}
        </div>
      </div>
    </>
  );
}

export default Register;

